import { api } from "infra/axios";
import { Contato } from "../types";

export async function enviarContato(payload: Contato) {
  const url = `/v1/fale-conosco`;

  return await api.post(url, payload);
}
